import React from 'react'
import { Script } from '@s4l/react-facade'

const GoogleAdSense = () => {
  const adSenseId = process.env.NEXT_PUBLIC_GOOGLE_AD_SENSE_ID

  if (!adSenseId) {
    return null
  }

  return (
    <Script
      id="google-ad-sense"
      strategy="afterInteractive"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adSenseId}`}
      crossOrigin="anonymous"
    />
  )
}

GoogleAdSense.displayName = 'GoogleAdSense'

export default GoogleAdSense
